import {
  COJG_FUND_GET_LIST,
  COJG_FUND_GET_LIST_SUCCESS,
  COJG_FUND_GET_LIST_ERROR,
  COJG_FUND_GET_LIST_WITH_FILTER,
  COJG_FUND_GET_LIST_WITH_ORDER,
  COJG_FUND_GET_LIST_SEARCH,
} from '../../actions';

const INIT_STATE = {
  cojgFunds: [],
  cojgFund: [],
  error: '',
  filter: null,
  searchKeyword: '',
  orderColumn: null,
  loading: false,
  labels: [
    { label: 'EDUCATION', color: 'secondary' },
    { label: 'NEW FRAMEWORK', color: 'primary' },
    { label: 'PERSONAL', color: 'info' },
  ],
  orderColumns: [
    { column: 'id', label: 'Id' },
    { column: 'name', label: 'Name' },
    { column: 'hid', label: 'HST' },
    { column: 'pcc', label: 'PCC' },
    { column: 'note', label: 'Note' },
  ],
  categories: ['Flexbox', 'Sass', 'React'],
  selectedItems: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case COJG_FUND_GET_LIST:
      return { ...state, loading: false };

    case COJG_FUND_GET_LIST_SUCCESS:
      return { ...state, loading: true, cojgFunds: action.payload, cojgFund: action.payload };

    case COJG_FUND_GET_LIST_ERROR:
      return { ...state, loading: true, error: action.payload };

    case COJG_FUND_GET_LIST_WITH_FILTER:
      if (action.payload.column === '' || action.payload.value === '') {
        return { ...state, loading: true, cojgFund: state.cojgFunds, filter: null };
      } else {
        const filteredItems = state.cojgFunds.filter(
          item => item[action.payload.column] === action.payload.value
        );
        return {
          ...state,
          loading: true,
          cojgFund: filteredItems,
          filter: {
            column: action.payload.column,
            value: action.payload.value,
          },
        };
      }

    case COJG_FUND_GET_LIST_WITH_ORDER:
      if (action.payload === '') {
        return { ...state, loading: true, cojgFund: state.cojgFund, orderColumn: null };
      } else {
        const sortedItems = state.cojgFund.sort((a, b) => {
          if (a[action.payload] < b[action.payload]) return -1;
          else if (a[action.payload] > b[action.payload]) return 1;
          return 0;
        });
        return {
          ...state,
          loading: true,
          COJG_FUND: sortedItems,
          orderColumn: state.orderColumns.find(x => x.column === action.payload),
        };
      }

    case COJG_FUND_GET_LIST_SEARCH:
      if (action.payload === '') {
        return { ...state, cojgFund: state.cojgFunds };
      } else {
        const keyword = action.payload.toLowerCase();
        const searchItems = state.cojgFinancials.filter(
          item =>
            String(item.id).startsWith(keyword) ||
            String(item.title.toLowerCase()).startsWith(keyword) ||
            String(item.max).startsWith(keyword) ||
            String(item.prerequisits.toLowerCase()).startsWith(keyword) ||
            String(item.cost).startsWith(keyword) ||
            String(item.stats).startsWith(keyword) ||
            String(item.hide).startsWith(keyword)
        );
        return { ...state, loading: true, cojgFund: searchItems, searchKeyword: action.payload };
      }
    default:
      return { ...state };
  }
};
